import axios from 'axios';
import { CLIENT_COMPLETED, CURRENT_UPCOMMING, GET_COMPLETED_CONTEST_LIST, GET_CONTEST_LIST, GET_PLAYERS_BY_MATCH, GET_TEAMS_ALL, GET_USER_CONTEST, GET_USER_TEAM_DETAILS, JOIN_CONTEST, SAVE_USER_TEAM } from './url';
import { getAuthHeaders } from './authUtils';
import { useAuth } from '../context/AuthContext';

class FantacyServiceClass {

    async getCurrentUpcomingService() {
        const headers = getAuthHeaders();
        return await axios.get(`${CURRENT_UPCOMMING}`, {
            headers: headers,
        });
    }

    async saveUserTeamService(teamData) {
        const headers = getAuthHeaders();
        return await axios.post(`${SAVE_USER_TEAM}`, teamData, {
            headers: headers,
        });
    }

    async joinContestService(payload) {
        const headers = getAuthHeaders();
        return await axios.post(`${JOIN_CONTEST}`, payload, {
            headers: headers,
        });
    }

    async GetTeamsAllService(matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_TEAMS_ALL}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async GetPlayersByMatchService(matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_PLAYERS_BY_MATCH}/${matchId}`, {
            headers: headers,
        });
    }

    async GetContestListService(matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_CONTEST_LIST}?matchId=${matchId}`, {
            headers: headers,
        });
    }
    
    async GetUserContestService(matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_USER_CONTEST}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async GetCompletedContestListService(matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_COMPLETED_CONTEST_LIST}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async GetUserTeamDetailsService(teamId, matchId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_USER_TEAM_DETAILS}?teamId=${teamId}&matchId=${matchId}`, {
            headers: headers,
        });
    }

    async GetClientCompletedService() {
        const headers = getAuthHeaders();
        return await axios.get(`${CLIENT_COMPLETED}`, {
            headers: headers,
        });
    }

}

const FantacyService = new FantacyServiceClass();
export default FantacyService;
